module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/sign-out-dd7539bfe157745e7b8890a135e231a6.svg";